module.exports = __webpack_public_path__ + "static/undraw_science_fqhl-6604a1c30d5276faa2350347668a9760.svg";